var _sodipodiNamedview, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473.34,
    height: 145.81,
    viewBox: "0 0 125.23787 38.578895",
    id: "svg454",
    inkscapeVersion: "1.2.1 (9c6d41e410, 2022-07-14)",
    sodipodiDocname: "cardiotrackLogo.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview456",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    "inkscapeDocument-units": "mm",
    showgrid: "false",
    inkscapeZoom: 0.914906,
    inkscapeCx: 396.76207,
    inkscapeCy: 298.93781,
    inkscapeWindowWidth: 5120,
    inkscapeWindowHeight: 1369,
    inkscapeWindowX: -8,
    inkscapeWindowY: -8,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "layer1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs451"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,227.969 H 548.04 V 0 H 0 Z",
    id: "path23"
  })))), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19",
    transform: "matrix(0.35277777,0,0,-0.35277777,-34.049123,60.774543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g21",
    clipPath: "url(#clipPath25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g27",
    transform: "translate(115.1042,92.8729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.264,0 -10.757,-4.697 -10.757,-11.574 0,-6.876 4.493,-11.573 10.757,-11.573 3.801,0 6.987,1.04 9.362,3.041 0.824,0.693 2.059,0.584 2.82,-0.177 l 1.505,-1.506 c 0.789,-0.789 0.826,-2.082 0.043,-2.878 -3.287,-3.344 -8.053,-5.221 -14.071,-5.221 -10.757,0 -18.246,7.421 -18.246,18.314 0,10.962 7.489,18.45 18.246,18.45 5.685,0 10.287,-1.596 13.584,-4.52 0.826,-0.731 0.879,-2.007 0.164,-2.847 l -1.7,-1.998 C 11.007,-3.311 9.777,-3.473 8.924,-2.813 6.574,-0.995 3.587,0.057 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g31",
    transform: "translate(156.5681,75.9891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 2.362 c 0,0.537 -0.436,0.974 -0.974,0.974 h -8.83 c -5.106,0 -7.489,-1.362 -7.489,-4.834 0,-3.269 2.655,-5.379 7.013,-5.379 5.582,0 9.872,2.928 10.28,6.877 m 0.068,-11.397 v 0 c 0,1.113 -1.255,1.702 -2.155,1.047 -2.514,-1.825 -5.858,-2.722 -9.828,-2.722 -7.829,0 -12.731,4.834 -12.731,11.233 0,6.605 4.97,10.825 13.685,10.894 H 0 v 1.09 c 0,4.56 -2.928,7.284 -8.646,7.284 -2.998,0 -6.096,-0.913 -9.208,-2.74 -0.836,-0.491 -1.915,-0.199 -2.406,0.637 l -1.219,2.075 c -0.587,1 -0.231,2.296 0.786,2.858 4.17,2.303 7.735,3.501 13.749,3.501 9.327,0 14.569,-4.765 14.637,-12.731 L 7.757,-11.258 C 7.76,-12.071 7.101,-12.731 6.288,-12.731 H 1.402 c -0.736,0 -1.334,0.597 -1.334,1.334",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g35",
    transform: "translate(191.8356,98.1044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.416 c 0,-0.759 -0.603,-1.387 -1.361,-1.406 -6.478,-0.168 -10.568,-4.272 -11.16,-10.044 -0.004,-0.039 -0.006,-0.079 -0.006,-0.119 v -17.621 c 0,-0.686 -0.556,-1.241 -1.241,-1.241 h -5.419 c -0.646,0 -1.17,0.524 -1.17,1.17 V 0.158 c 0,0.671 0.544,1.215 1.215,1.215 h 5.527 c 0.6,0 1.088,-0.487 1.088,-1.088 v -5.208 c 0,-0.242 0.315,-0.318 0.436,-0.108 2.239,3.896 5.803,6.148 10.366,6.593 C -0.805,1.652 0,0.925 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g39",
    transform: "translate(223.0856,81.2313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,7.013 -4.562,11.914 -11.098,11.914 -6.535,0 -11.097,-4.97 -11.165,-11.914 0.068,-6.876 4.562,-11.778 11.165,-11.778 C -4.562,-11.778 0,-6.876 0,0 m 7.83,30.999 v -47.712 c 0,-0.696 -0.564,-1.261 -1.262,-1.261 H 1.261 C 0.564,-17.974 0,-17.409 0,-16.713 v 2.453 c 0,0.752 -0.928,1.112 -1.426,0.548 -2.639,-2.989 -6.474,-4.602 -11.305,-4.602 -10.417,0 -17.361,7.557 -17.361,18.586 0,10.893 7.012,18.314 17.225,18.314 5.053,0 8.99,-1.774 11.68,-4.974 C -0.78,13.129 0,13.391 0,14.022 v 16.851 c 0,0.923 0.748,1.67 1.67,1.67 h 4.615 c 0.854,0 1.545,-0.691 1.545,-1.544",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g43",
    transform: "translate(246.3249,97.8417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -32.949 c 0,-0.904 -0.732,-1.635 -1.636,-1.635 h -4.491 c -0.903,0 -1.635,0.731 -1.635,1.635 V 0 c 0,0.903 0.732,1.636 1.635,1.636 h 4.491 C -0.732,1.636 0,0.903 0,0 m 0.681,11.983 c 0,-2.654 -1.976,-4.629 -4.563,-4.629 -2.587,0 -4.56,1.975 -4.56,4.629 0,2.724 1.973,4.699 4.56,4.699 2.587,0 4.563,-1.975 4.563,-4.699",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g47",
    transform: "translate(259.238,81.2987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-7.012 4.561,-11.777 11.097,-11.777 6.467,0 11.029,4.765 11.029,11.777 0,6.945 -4.562,11.778 -11.029,11.778 C 4.561,11.778 0,6.945 0,0 m 29.955,0.137 c 0,-10.961 -7.693,-18.45 -18.858,-18.45 -11.234,0 -18.927,7.489 -18.927,18.45 0,10.893 7.693,18.313 18.927,18.313 11.165,0 18.858,-7.42 18.858,-18.313",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g51",
    transform: "translate(315.5593,66.7635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.237,-0.721 -0.103,-1.493 -0.776,-1.841 -2.504,-1.293 -5.102,-2.006 -7.75,-2.006 -5.448,0 -10.145,3.132 -10.145,10.553 v 17.71 c 0,0.597 -0.484,1.081 -1.081,1.081 h -2.508 c -0.838,0 -1.516,0.679 -1.516,1.517 v 2.821 c 0,0.838 0.678,1.517 1.516,1.517 h 2.766 c 0.455,0 0.823,0.369 0.823,0.823 l 0.019,13.332 c 0,0.838 0.678,1.516 1.516,1.516 h 4.728 c 0.838,0 1.516,-0.678 1.516,-1.516 l -0.017,-13.065 c 0,-0.602 0.488,-1.09 1.091,-1.09 h 8.081 c 0.838,0 1.516,-0.679 1.516,-1.517 v -2.821 c 0,-0.838 -0.678,-1.517 -1.516,-1.517 h -8.507 c -0.367,0 -0.665,-0.298 -0.665,-0.665 V 8.136 c 0,-3.744 1.43,-4.902 3.881,-4.902 1.227,0 2.494,0.308 3.942,0.894 0.819,0.331 1.752,-0.08 2.028,-0.92 z",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g55",
    transform: "translate(341.6188,98.2421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -4.729 c 0,-0.661 -0.523,-1.218 -1.184,-1.228 -6.573,-0.096 -10.73,-4.214 -11.337,-10.029 -0.004,-0.05 -0.007,-0.103 -0.007,-0.154 l 0.001,-17.613 c 0,-0.681 -0.552,-1.231 -1.232,-1.231 h -5.366 c -0.681,0 -1.231,0.55 -1.231,1.231 v 33.665 c 0,0.731 0.592,1.323 1.323,1.323 h 5.233 c 0.702,0 1.273,-0.569 1.273,-1.272 v -4.399 c 0,-0.41 0.531,-0.558 0.751,-0.21 2.275,3.613 5.768,5.689 10.189,6.083 C -0.739,1.514 0,0.851 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g59",
    transform: "translate(366.402,75.9891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 2.001 c 0,0.737 -0.598,1.335 -1.334,1.335 h -8.47 c -5.105,0 -7.488,-1.362 -7.488,-4.834 0,-3.269 2.655,-5.379 7.012,-5.379 5.583,0 9.872,2.928 10.28,6.877 m 0.068,-11.397 v 2.221 c 0,0.304 -0.364,0.436 -0.572,0.215 -2.607,-2.759 -6.539,-4.111 -11.41,-4.111 -7.829,0 -12.732,4.834 -12.732,11.233 0,6.605 4.971,10.825 13.685,10.894 H 0 v 1.09 c 0,4.56 -2.927,7.284 -8.646,7.284 -3.098,0 -6.303,-0.976 -9.52,-2.926 -0.648,-0.393 -1.488,-0.207 -1.872,0.446 l -1.74,2.962 c -0.424,0.721 -0.164,1.644 0.564,2.056 4.4,2.495 8.008,3.793 14.27,3.793 9.327,0 14.569,-4.765 14.637,-12.731 L 7.758,-11.394 C 7.76,-12.132 7.162,-12.731 6.424,-12.731 H 1.403 c -0.737,0 -1.335,0.597 -1.335,1.334",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g63",
    transform: "translate(397.9255,92.8729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.264,0 -10.757,-4.697 -10.757,-11.574 0,-6.876 4.493,-11.573 10.757,-11.573 3.715,0 6.843,0.993 9.2,2.906 0.93,0.755 2.285,0.654 3.132,-0.193 l 1.132,-1.131 c 0.958,-0.958 0.903,-2.502 -0.075,-3.44 -3.273,-3.132 -7.917,-4.883 -13.73,-4.883 -10.756,0 -18.245,7.421 -18.245,18.314 0,10.962 7.489,18.45 18.245,18.45 5.484,0 9.961,-1.484 13.231,-4.215 1.026,-0.856 1.179,-2.376 0.312,-3.393 L 11.898,-2.265 C 11.092,-3.213 9.691,-3.375 8.69,-2.635 6.377,-0.927 3.469,0.055 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g67",
    transform: "translate(431.61,79.0848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -5.152,-5.438 c -0.15,-0.158 -0.232,-0.366 -0.232,-0.583 v -8.96 c 0,-0.468 -0.379,-0.846 -0.845,-0.846 h -6.138 c -0.468,0 -0.846,0.378 -0.846,0.846 v 48.446 c 0,0.677 0.548,1.224 1.225,1.224 h 5.426 c 0.651,0 1.178,-0.526 1.178,-1.176 V 5.034 c 0,-0.31 0.376,-0.465 0.594,-0.244 l 15.157,15.351 c 0.159,0.161 0.376,0.252 0.602,0.252 h 6.655 c 0.744,0 1.125,-0.893 0.611,-1.431 L 6.653,6.852 C 6.382,6.568 6.342,6.135 6.556,5.807 l 13.218,-20.328 c 0.366,-0.562 -0.038,-1.306 -0.709,-1.306 h -7.238 c -0.289,0 -0.557,0.146 -0.713,0.389 L 1.326,-0.126 C 1.03,0.337 0.378,0.398 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g71",
    transform: "translate(288.3815,172.2743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -4.294,0 -8.537,-1.696 -11.713,-4.617 -14.888,-1.696 -19.131,0 -23.424,0 c -4.461,0 -8.595,-1.691 -11.639,-4.763 -3.004,-3.033 -4.638,-7.114 -4.598,-11.491 0.005,-0.516 0.034,-1.03 0.081,-1.543 h 3.87 c -0.06,0.526 -0.102,1.052 -0.106,1.578 -0.032,3.344 1.207,6.451 3.485,8.75 2.316,2.338 5.479,3.625 8.907,3.625 3.821,0 7.746,-1.833 10.244,-4.785 l 1.467,-1.733 1.468,1.733 c 2.498,2.952 6.423,4.785 10.245,4.785 7.061,0 12.388,-5.328 12.392,-12.393 0.007,-14.282 -19.428,-27.401 -24.081,-30.336 -1.701,1.12 -5.397,3.667 -9.397,7.118 h -5.733 c 6.668,-6.421 13.548,-10.688 14.103,-11.027 l 0.979,-0.599 0.991,0.577 c 0.273,0.159 6.765,3.962 13.35,10.002 9.05,8.302 13.636,16.466 13.632,24.267 C 16.231,-7.131 9.1,0 0,0",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g75",
    transform: "translate(257.0436,141.2069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.274,0.18 -2.148,1.396 -2.148,2.682 v 7.411 c 0,1.287 0.874,2.503 2.148,2.682 1.552,0.219 2.881,-0.979 2.881,-2.488 V 2.488 C 2.881,0.979 1.552,-0.219 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g79",
    transform: "translate(271.7214,141.1805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.389,0 -2.515,1.126 -2.515,2.515 v 7.798 c 0,1.389 1.126,2.515 2.515,2.515 1.389,0 2.515,-1.126 2.515,-2.515 V 2.515 C 2.515,1.126 1.389,0 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g83",
    transform: "translate(264.2018,135.8593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.274,0.18 -2.149,1.396 -2.149,2.683 v 18.105 c 0,1.287 0.875,2.503 2.149,2.683 1.551,0.218 2.88,-0.981 2.88,-2.49 V 2.489 C 2.88,0.979 1.551,-0.219 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g87",
    transform: "translate(252.988,147.5946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-1.413 -1.146,-2.56 -2.56,-2.56 -1.413,0 -2.558,1.147 -2.558,2.56 0,1.413 1.145,2.559 2.558,2.559 C -1.146,2.559 0,1.413 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g91",
    transform: "translate(281.1921,147.5946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-1.413 -1.146,-2.56 -2.559,-2.56 -1.414,0 -2.559,1.147 -2.559,2.56 0,1.413 1.145,2.559 2.559,2.559 C -1.146,2.559 0,1.413 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g95",
    transform: "translate(285.6257,147.5946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-0.815 -0.66,-1.476 -1.476,-1.476 -0.815,0 -1.475,0.661 -1.475,1.476 0,0.815 0.66,1.476 1.475,1.476 C -0.66,1.476 0,0.815 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g99",
    transform: "translate(246.3737,147.5946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-0.815 -0.66,-1.476 -1.476,-1.476 -0.815,0 -1.475,0.661 -1.475,1.476 0,0.815 0.66,1.476 1.475,1.476 C -0.66,1.476 0,0.815 0,0",
    style: {
      fill: "#5fabd7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path101"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3764454a841335db1da7073845835d91.svg";
export { ForwardRef as ReactComponent };